import type { SVGProps } from 'react';
const SvgViewArray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_array_svg__a)">
      <path
        fill="currentColor"
        d="M4 18h3V5H4v13ZM18 5v13h3V5h-3ZM8 18h9V5H8v13Z"
      />
    </g>
    <defs>
      <clipPath id="view_array_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewArray;
